import { render, staticRenderFns } from "./Prob5.vue?vue&type=template&id=39eefdf5&scoped=true&"
import script from "./Prob5.vue?vue&type=script&lang=js&"
export * from "./Prob5.vue?vue&type=script&lang=js&"
import style0 from "./Prob5.vue?vue&type=style&index=0&id=39eefdf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eefdf5",
  null
  
)

export default component.exports